import { render, staticRenderFns } from "./BoardSubsectionEditor.vue?vue&type=template&id=9fe24bae&scoped=true&"
import script from "./BoardSubsectionEditor.vue?vue&type=script&lang=ts&"
export * from "./BoardSubsectionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe24bae",
  null
  
)

export default component.exports